import React from 'react';
import PropTypes from 'prop-types';
import { FlagVariants, getFlagUrl } from './flag-consts';
import * as S from './styled';

export const Flag = ({
  code,
  alt = '',
  variant = FlagVariants.SQUARE,
  size = 16,
  width = size,
  height = size,
  isRounded = variant === FlagVariants.SQUARE,
  className
}) => {
  if (!code) return null;

  return (
    <S.Flag
      className={className}
      alt={alt}
      src={getFlagUrl(code, variant)}
      width={width}
      height={height}
      $isRounded={isRounded}
    />
  );
};

Flag.propTypes = {
  code: PropTypes.string,
  alt: PropTypes.string,
  variant: PropTypes.oneOf(Object.values(FlagVariants)),
  size: PropTypes.number,
  width: PropTypes.number,
  height: PropTypes.number,
  isRounded: PropTypes.bool,
  className: PropTypes.string
};
